$(function () {
	const yearFilterSlider = $('.b-year-filter');

	const settings = {
		slidesToShow: 2,
		arrows: true,
		dots: false,
		swipeToSlide: true,
		touchThreshold: 10,
		infinite: false,
		mobileFirst: true,
		prevArrow: '<div class="b-slider-arrows__prev"><svg width="20" height="34" viewBox="0 0 20 34" xmlns="http://www.w3.org/2000/svg"><path d="M16.5859 33.4142L0.171665 17L16.5859 0.585788L19.4143 3.41422L5.82852 17L19.4143 30.5858L16.5859 33.4142Z"></path></svg></div>',
		nextArrow: '<div class="b-slider-arrows__next"><svg width="20" height="34" viewBox="0 0 20 34" xmlns="http://www.w3.org/2000/svg"><path d="M16.5859 33.4142L0.171665 17L16.5859 0.585788L19.4143 3.41422L5.82852 17L19.4143 30.5858L16.5859 33.4142Z"></path></svg></div>',
		responsive: [
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 3,
				},
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 4,
				},
			},
			{
				breakpoint: 1000,
				settings: {
					slidesToShow: 5,
				},
			},
			{
				breakpoint: 1200,
				settings: {
					slidesToShow: 6,
				},
			},
			{
				breakpoint: 1600,
				settings: {
					slidesToShow: 8,
				},
			},
			{
				breakpoint: 1800,
				settings: {
					slidesToShow: 9,
				},
			},

		]
	};

	yearFilterSlider.not('.slick-initialized').slick(settings);
});
